import type { BrandWarning } from '@innovationdepartment/proxima-sdk-axios';
import type { TableConfig } from '@innovationdepartment/proxima-ui';
import { useBrandWarnings } from 'hooks';
import { useAdAccountStore, useIntegrationsStore } from 'stores';
import type { BrandListIntegrationStatusProps } from 'types/integrations';
import { formatDateTimeFromIso } from 'utils/formatDate';
import BrandWarningsView from './BrandWarnings.View';

const formatBrandWarning = (brandWarning: BrandWarning) => {
  const { createdAt } = brandWarning;
  return {
    ...brandWarning,
    createdAt: formatDateTimeFromIso(createdAt)
  };
};

const BrandWarnings = () => {
  const { brandWarnings, pagination, goToNextPage, goToPrevPage, loading, brand } =
    useBrandWarnings();
  const { getAllIntegrations } = useIntegrationsStore();
  const activeIntegrations = getAllIntegrations();
  const { metaAdAccountsList } = useAdAccountStore();

  const integrationsWithStatus = activeIntegrations.reduce(
    (acc, integration) => {
      if (!acc[integration.type]) acc[integration.type] = [];
      acc[integration.type].push(integration);
      return acc;
    },
    {} as BrandListIntegrationStatusProps['integrations']
  );

  const brandWarningsConfig: TableConfig<BrandWarning> = {
    formatter: formatBrandWarning,
    columns: {
      order: ['message', 'createdAt'],
      message: { label: 'Warning' },
      createdAt: { label: 'Time' }
    }
  };

  const maxPage = Math.ceil(pagination.total / pagination.pageSize);
  const hasNext = pagination.pageNumber < maxPage;
  const hasPrev = pagination.pageNumber > 1;

  return (
    <BrandWarningsView
      brand={brand}
      adAccountId={metaAdAccountsList.at(0)?.adAccountId}
      integrationsWithStatus={integrationsWithStatus}
      loading={loading}
      hasNext={hasNext}
      hasPrev={hasPrev}
      handlePagination={(action: 'prev' | 'next') =>
        action === 'next' ? goToNextPage() : goToPrevPage()
      }
      brandWarnings={brandWarnings}
      tableConfig={brandWarningsConfig}
    />
  );
};

export default BrandWarnings;
